import { cva, VariantProps } from 'class-variance-authority';

export const iconVariant = cva(['rounded-lg', 'w-full'].join(' '), {
  variants: {
    variant: {
      inherit: 'text-inherit',
      primary: 'text-emerge-teal',
      secondary: 'text-white',
      input: 'text-emerge-navy'
    },
    size: {
      xxs: 'w-3 h-3',
      xs: 'w-4 h-4',
      sm: 'w-5 h-5',
      md: 'w-6 h-6',
      lg: 'w-8 h-8',
      '2xl': 'w-12 h-12',
      '4xl': 'w-18 h-18'
    },
    iconColor: {
      amber: 'text-emerge-amber',
      purple: 'text-emerge-purple',
      green: 'text-emerge-teal',
      navy: 'text-emerge-navy',
      white: 'text-white'
    }
  },
  defaultVariants: {
    variant: 'inherit',
    size: 'sm'
  }
});

export type IconVariantProps = VariantProps<typeof iconVariant>;
export type TIconColor = 'amber' | 'purple' | 'green' | 'navy' | 'white';
